import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class User extends Model {
  resource() {
    return 'users'
  }

  get memberSince() {
    return dayjs.utc(this.created_at).format('MMM YYYY')
  }
}
